<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2hgkxZ/tc-custom/9781685505202.jpg?1723950724478" alt="This image is the cover for the book Vampire Food"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vampire Food
      </h1>
      <p class="bookDescription body article font2">
        <p>A former blood slave. A strapping vampire. More zucchinis than any man could eat.<br/><br/>Rue Yarrow was rescued from a blood bar and taken to a gated community of supernaturals. Haunted by nightmares and memories, he does his best to avoid people. His only solace is his garden, where he uses his magic to grow an abundance of vegetables. But one day, it isn't the zucchinis greeting him, but a severed human head.<br/><br/>Noah Caramine wants as little drama as possible, and interfering with a vampire clan's business is never a good idea. He's never met a magic user and is curious about Rue, but he fears there will be consequences for stealing the blood slaves. <br/><br/>When body parts start popping up inside the walls, Noah doesn't know if someone is trying to frame them for murder or distract them from keeping the blood slaves safe. Rue never believed he'd go near a vampire again, but when threats are drawing closer, he turns to Noah. Who better to keep him safe from vampires than a vampire?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Holly Day
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?485bb8c4